// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PMinusCircleOutlinedSvg from "@fishx/icons-svg/es/asn/PMinusCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var PMinusCircleOutlined = function PMinusCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PMinusCircleOutlinedSvg
  }));
};

PMinusCircleOutlined.displayName = 'PMinusCircleOutlined';
export default React.forwardRef(PMinusCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PMinusCircleOutlined.js
// module id = 3512
// module chunks = 0